module.exports = __webpack_public_path__ + "img/myposition_wf_킬리안 음바페.f2e70cc3.png";